module.exports = __webpack_public_path__ + "static/media/DigiFleet-Logo_Sort grå u baggrund.f2ed52ce.png";